<template>
  <div>
    <div class="breadcrumb">
      <breadcrumb
          main_step_name="Organisation"
          sub_step_name="Utilities"
          step_name="SMTP configuration"
          @goToMainStep="routeToMainStep"
          @goToSubStep="routeToSubStep"
          >
      </breadcrumb>
    </div>

    <div>
        <tl-header type="h1">Email configuration</tl-header>
        <div class="selection">
          <tl-select
                label="Entity"
                :options="legalEntities"
                labelText="name"
                @change="(le)=>formData.le_id=le.id"
              >
          </tl-select>
        </div>
        <div v-show="formData.le_id" class="selection">
          <tl-select
                label="Select Paygroup"
                :options="payGroups"
                labelText="name"
                @change="(pg)=>formData.payGroupList[pg.name]='pgName'"
              >
          </tl-select>
        </div>
        <div v-show="paygroupSelected" class="config-details">
          <txt label="Login" type="email" v-model="formData.loginId"></txt>
          <txt label="Password" type="password"  v-model="formData.password"></txt>
          <txt label="Outgoing server" type="text" v-model="formData.outgoingServer"></txt>
          <txt label="SMTP Port" type="number" v-model="formData.SMTPPort"></txt>
          <txt label="Display Name" type="text" v-model="formData.displayName"></txt>
          <tl-checkbox label="Requires SSL encryption" v-model="formData.SSLEncryption"></tl-checkbox>
          <tl-checkbox label="Would you like to send test mail" v-model="formData.sendTestMail"></tl-checkbox>
        </div>
        <bottom-action-container>
          <template slot="end">
            <btn-grp>
              <btn text="Cancel" type="secondary" @click/>
              <btn text="Save" type="primary" @click="save" />
            </btn-grp>
          </template>
        </bottom-action-container>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
export default {
  data() {
    return {
      formData: {
        le_id: null,
        loginId: null,
        password: null,
        outgoingServer: null,
        SMTPPort: null,
        displayName: null,
        SSLEncryption: false,
        sendTestMail: false,
        paygroupsList: null
      }
    }
  },
  computed: {
      ...mapState({
        legalEntities: state => state.onboard.legal_entities.data,
        payGroups: state => state.dashboard.payroll.monthlypayroll.payGroup.data,
        orgId: state => state.onboard.organization.data.id
      }),
      paygroupSelected() {
        if (this.$_.isEmpty(this.formData.payGroupList)) {
          return false;
        }
        else {
          return true;
        }
      }
  },
  mounted() {
    //console.log("SMTP",this.orgId);
    if (this.$_.isEmpty(this.legalEntities)) this.act_fetchLegalEntities(this.orgId);

    if (this.$_.isEmpty(this.payGroups)) this.act_fetchPaygroups();
  },
  methods: {
    ...mapActions({
      act_fetchLegalEntities: 'onboard/legal_entities/fetchAll',
      act_fetchPaygroups: 'dashboard/payroll/monthlypayroll/payGroup/fetchAll',
      act_fetch: 'dashboard/organisation/utilities/smtp/fetchAll',
      act_create: 'dashboard/organisation/utilities/smtp/create',
      act_update: 'dashboard/organisation/utilities/smtp/update'
    }),
    async save() {
      //console.log(this.formData);
      //console.log(this.legalEntities);
    },
    routeToMainStep() {

    },
    routeToSubStep() {

    },
    async save() {
      try {
        this.$root._data.isSaving = true;
        await this.act_create({
          data: this.formData
        });
        setTimeout(() => {
          this.$root._data.isSaving = false;
        }, 500);
      }
      catch(err) {
        this.$root._data.isSaving = false;
        //console.log(err);
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.selection {
  max-width: 300px;
}
.config-details {
  margin-top: 20px;
  *:nth-child(n) {
    margin-bottom: 20px;
  }
}
.breadcrumb {
  padding: 15px 0px 0px 15px;
}
</style>
